// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-post .hyphenated[data-v-3874bbb3]{height:1px;width:20px;background-color:#0b2340;margin-left:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
